"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EnvironmentSound;

var _react = _interopRequireDefault(require("react"));

var _RainSound = _interopRequireDefault(require("./components/RainSound/RainSound"));

var _ThunderSound = _interopRequireDefault(require("./components/ThunderSound/ThunderSound"));

var _WindSound = _interopRequireDefault(require("./components/WindSound/WindSound"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EnvironmentSound(_ref) {
  var _ref$rain = _ref.rain,
      rain = _ref$rain === void 0 ? false : _ref$rain,
      _ref$thunder = _ref.thunder,
      thunder = _ref$thunder === void 0 ? false : _ref$thunder,
      _ref$wind = _ref.wind,
      wind = _ref$wind === void 0 ? false : _ref$wind,
      _ref$volRain = _ref.volRain,
      volRain = _ref$volRain === void 0 ? 60 : _ref$volRain,
      _ref$volThunder = _ref.volThunder,
      volThunder = _ref$volThunder === void 0 ? 75 : _ref$volThunder,
      _ref$volWind = _ref.volWind,
      volWind = _ref$volWind === void 0 ? 75 : _ref$volWind;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, rain && /*#__PURE__*/_react.default.createElement(_RainSound.default, {
    maxVolume: volRain
  }), thunder && /*#__PURE__*/_react.default.createElement(_ThunderSound.default, {
    maxVolume: volThunder
  }), wind && /*#__PURE__*/_react.default.createElement(_WindSound.default, {
    maxVolume: volWind
  }));
}